export default __webpack_public_path__ + "static/media/c006-3.f00a794b.jpg";